import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import Home from './components/Home';
import RequestPin from './components/RequestPin';
import GrossReceiptAccountSearch from './components/GrossReceiptAccountSearch';
import ReturnEntry from './components/ReturnEntry/ReturnEntry';
import PrintSubmittedReturn from './components/PrintSubmittedReturn';
import './custom.css';
import VerifyReturn from './components/VerifyReturn';

export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <Layout>
                <Route exact path="/" component={Home} />
                <Route exact path="/request-pin" component={RequestPin} />
                <Route exact path="/account-search" component={GrossReceiptAccountSearch} />
                <Route exact path="/enter-return" component={ReturnEntry} />
                <Route exact path="/enter-return/print" component={PrintSubmittedReturn} />
                <Route exact path="/enter-return/verify" component={VerifyReturn} />
            </Layout>
        );
    }
}